import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import t from "../../PopupTemplate.js";
import { symbolTypesCluster as o } from "../../symbols.js";
import { JSONSupport as s } from "../../core/JSONSupport.js";
import { clone as r } from "../../core/lang.js";
import { toPt as p } from "../../core/screenUtils.js";
import { property as i } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as l } from "../../core/accessorSupport/decorators/subclass.js";
import a from "./AggregateField.js";
import { popupEnabled as u, labelsVisible as n } from "./commonProperties.js";
import c from "./LabelClass.js";

var _m;

var d = _m = /*#__PURE__*/function (_s) {
  _inherits(m, _s);

  var _super = _createSuper(m);

  function m(e) {
    var _this;

    _classCallCheck(this, m);

    _this = _super.call(this, e), _this.type = "cluster", _this.clusterRadius = p("80px"), _this.clusterMinSize = p("12px"), _this.clusterMaxSize = p("50px"), _this.popupEnabled = !0, _this.popupTemplate = null, _this.symbol = null, _this.labelingInfo = null, _this.labelsVisible = !0, _this.fields = null;
    return _this;
  }

  _createClass(m, [{
    key: "clone",
    value: function clone() {
      return new _m({
        clusterRadius: this.clusterRadius,
        clusterMinSize: this.clusterMinSize,
        clusterMaxSize: this.clusterMaxSize,
        labelingInfo: r(this.labelingInfo),
        labelsVisible: this.labelsVisible,
        fields: r(this.fields),
        popupEnabled: this.popupEnabled,
        popupTemplate: r(this.popupTemplate)
      });
    }
  }]);

  return m;
}(s);

e([i({
  type: ["cluster"],
  readOnly: !0,
  json: {
    write: !0
  }
})], d.prototype, "type", void 0), e([i({
  type: Number,
  cast: function cast(e) {
    return "auto" === e ? e : p(e);
  },
  json: {
    write: !0
  }
})], d.prototype, "clusterRadius", void 0), e([i({
  type: Number,
  cast: p,
  json: {
    write: !0
  }
})], d.prototype, "clusterMinSize", void 0), e([i({
  type: Number,
  cast: p,
  json: {
    write: !0
  }
})], d.prototype, "clusterMaxSize", void 0), e([i(u)], d.prototype, "popupEnabled", void 0), e([i({
  type: t,
  json: {
    read: {
      source: "popupInfo"
    },
    write: {
      target: "popupInfo"
    }
  }
})], d.prototype, "popupTemplate", void 0), e([i({
  types: o
})], d.prototype, "symbol", void 0), e([i({
  type: [c],
  json: {
    read: {
      source: "drawingInfo.labelingInfo"
    },
    write: {
      target: "drawingInfo.labelingInfo"
    }
  }
})], d.prototype, "labelingInfo", void 0), e([i(n)], d.prototype, "labelsVisible", void 0), e([i({
  type: [a],
  json: {
    write: !0
  }
})], d.prototype, "fields", void 0), d = _m = e([l("esri.layers.support.FeatureReductionCluster")], d);
var b = d;
export { b as default };